import type { AgentArtifact } from "../api/e2e";

export const DOCUMENT_REFERENCE_PREFIX = "fdr-document://";
const DOCUMENT_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const DOCUMENT_REFERENCE_RE =
  /fdr-document:\/\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gu;

export function documentReferenceId(href: string | undefined): string | null {
  if (!href?.startsWith(DOCUMENT_REFERENCE_PREFIX)) return null;
  const documentId = href.slice(DOCUMENT_REFERENCE_PREFIX.length);
  return DOCUMENT_ID_RE.test(documentId) ? documentId : null;
}

export function citedDocumentIds(source: string): string[] {
  return Array.from(
    new Set(
      Array.from(source.matchAll(DOCUMENT_REFERENCE_RE), (match) => match[1]!),
    ),
  );
}

export function publicSourceOrigin(value: string | null): {
  domain: string;
  url: string;
} | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    return {
      domain: url.hostname.replace(/^www\./u, ""),
      url: url.toString(),
    };
  } catch {
    return null;
  }
}

function hex(bytes: ArrayBuffer): string {
  return Array.from(new Uint8Array(bytes), (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
}

export async function verifiedArtifactText(
  response: Response,
  artifact: AgentArtifact,
): Promise<string> {
  const bytes = await response.arrayBuffer();
  const digest = hex(await crypto.subtle.digest("SHA-256", bytes));
  if (bytes.byteLength !== artifact.size_bytes || digest !== artifact.sha256) {
    throw new Error("The agent summary failed its recorded artifact identity.");
  }
  return new TextDecoder().decode(bytes);
}
